// 关注时回复与帮助
import { BaseModel } from '../BaseModel';
export  class ReplyHelp extends BaseModel{    
    TimeSlot:any= []//时段
    Type:number=0//0、自定义；1、选择关键词
    ReplyTypeId:number= 2//回复类型:0、非定义时段回复，1、单图片；2、文本回复；3、外链图文；4、多媒体
    Title:string= ""//回复标题:
    Remarks:string= ""//回复简介
    LinkUrl:string= ""//选择外链图文
    ImgUrl:string= ""//回复图片
    Contents:string= ""//回复内容:
    AppReplyId:number=0//TA_AppReplyGraphic、TA_AppReplyImage、TA_AppReplyText、TA_AppReplyVoice表的ID
    AppReplyType:string=""//AppReplyText 文本，AppReplyImage 图片，AppReplyGraphic 图文、AppReplyVoice 多媒体
    AppReplyName:string=""
    MediaId:string=""
    Keyword:string=""
    State:number=1
    MultipleReplies:string="0"    
}